import './styles.css';
import DealPortalWhitePng from '../../assets/login_page/DealPortal-white.png';
import { Popover } from 'antd';
import { MoonOutlined, SettingOutlined, SunOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import { LocalStorageHelper } from '../../utils/LocalStorageHelper';

const AppHeader = () => {
  const content = () => {
    return (
      <>
        <MoonOutlined />
        <Switch
          className={'login-header-theme-switch'}
          defaultChecked={LocalStorageHelper.get('theme') === 'light'}
          onChange={(checked) => {
            if (checked) {
              LocalStorageHelper.set('theme', 'light');
            } else {
              LocalStorageHelper.set('theme', 'dark');
            }
            window.location.reload();
          }}
        />
        <SunOutlined />
      </>
    );
  };

  return (
    <div className={'login-page-header'}>
      <img src={DealPortalWhitePng} alt={'logo'} className={'header-logo'} />
      <Popover trigger="click" placement="bottomRight" content={content}>
        <SettingOutlined style={{ color: 'white' }} />
      </Popover>
    </div>
  );
};

export default AppHeader;
